// Carousel.js
import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CarouselShow = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 0,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    fade: true,
    arrows: true
  };

  return (
    <div className="carousel-container p-0 mx-2 mt-0 mb-3 rounded-3">
      <Slider {...settings}>
        <div className="carousel-item">
          <img
            src="https://i.postimg.cc/L5cT3SCB/Whats-App-Image-2024-07-17-at-16-02-05-be5900e5.jpg"
            className="d-block w-100"
            alt="Sunset Over the City"
          />
          <div className="carousel-caption d-none d-md-block">
            <h1>NOT ME BUT YOU</h1>
            <h5>
              Our vision is to build the youth with the mind and spirit to
              serve the society and work for the social uplift of the
              down-trodden masses of our nation as a movement.
            </h5>
          </div>
        </div>
        <div className="carousel-item">
          <img
            src="https://i.postimg.cc/1RBFZSZc/nss.jpg"
            className="d-block w-100"
            alt="Canyon at Night"
          />
          <div className="carousel-caption d-none d-md-block">
            <h1>NOT ME BUT YOU</h1>
            <h5>
              Our vision is to build the youth with the mind and spirit to
              serve the society and work for the social uplift of the
              down-trodden masses of our nation as a movement.
            </h5>
          </div>
        </div>
        <div className="carousel-item">
          <img
            src="https://i.postimg.cc/qgHpvKRs/IMG-5838.jpg"
            className="d-block w-100"
            alt="Cliff Above a Stormy Sea"
          />
          <div className="carousel-caption d-none d-md-block">
            <h1>NOT ME BUT YOU</h1>
            <h5>
              Our vision is to build the youth with the mind and spirit to
              serve the society and work for the social uplift of the
              down-trodden masses of our nation as a movement.
            </h5>
          </div>
        </div>
      </Slider>
    </div>
  );
};

export default CarouselShow;
